export const RENEWAL_FIELD_MAX_COUNT = 10;
export const SURVEY_URL = "https://api.apphud.com/survey";
